module.exports = __webpack_public_path__ + "static/media/ffo_stillpunkt.9d3c2a9e.jpg";